import { Link } from "react-router-dom";
import { Logo, CtaButton, MonoLabel } from "../components/kit";

export default function NotFound() {
  return (
    <div className="min-h-screen dot-grid flex flex-col" data-testid="not-found-page">
      <div className="max-w-6xl w-full mx-auto px-6 py-6">
        <Link to="/" data-testid="not-found-logo-link">
          <Logo className="h-5 sm:h-6" />
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-24">
        <div className="w-full max-w-md text-center">
          <div className="card-soft p-10 fade-up">
            <MonoLabel>ERROR 404</MonoLabel>
            <h1 className="mt-5 text-3xl sm:text-4xl leading-tight">
              <span className="font-serif-it block">Page</span>
              <span className="font-extrabold tracking-[-0.02em] block">not found</span>
            </h1>
            <p className="mt-4 text-[14px] text-[#54505B]">
              The page you're looking for doesn't exist or has been moved.
            </p>
            <Link to="/">
              <CtaButton className="mt-7 w-full justify-center" data-testid="not-found-home-btn">
                Back to home
              </CtaButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
